import {Industry } from "models/Company";

const IndustriesCustomer = (props: { companyName:string, industries:Industry[]}) => {

    return <>
        <h2 className="h6">{props.companyName} er oppført i disse bransjene hos 1881:</h2>
        <ul>
            {props.industries.map((industry, index) => {
                return (
                    <li key={industry.name}>{industry.name}</li>)
            })}
        </ul>
        <p><a href="https://kundeservice.1881.no/hc/no/articles/19307392067229-Kontakt-oss-Bedrift">Kontakt kundeservice</a> for å endre eller legge til bransjer</p>
    </>
}

export default IndustriesCustomer;